var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1448_44631)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.202 11.7382C24.7868 6.10047 19.0693 2.67743 13.4315 4.09264C9.02575 5.19864 5.82666 9.00649 5.49704 13.537C2.36875 14.0528 0.250951 17.007 0.766842 20.1353C1.22544 22.9164 3.63524 24.9531 6.45383 24.9419H11.2378V23.0283H6.45383C4.34016 23.0283 2.62667 21.3148 2.62667 19.2012C2.62667 17.0875 4.34016 15.374 6.45383 15.374C6.98228 15.374 7.41062 14.9457 7.41062 14.4172C7.40584 9.66141 11.2573 5.80219 16.0131 5.79747C20.13 5.79334 23.6739 8.70378 24.4702 12.7428C24.5489 13.1461 24.8761 13.4542 25.2835 13.5083C27.8992 13.8807 29.7177 16.3032 29.3453 18.9189C29.0108 21.2677 27.0054 23.0165 24.6329 23.0283H20.8057V24.9419H24.6329C28.3318 24.9307 31.3213 21.9231 31.3101 18.2241C31.3008 15.145 29.1932 12.4689 26.202 11.7382Z",
    fill: "#388F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3428 15.6532L11.5156 19.4804L12.8647 20.8295L15.0653 18.6384V27.8141H16.9789V18.6384L19.17 20.8295L20.519 19.4804L16.6919 15.6532C16.3187 15.2823 15.716 15.2823 15.3428 15.6532Z",
    fill: "#388F91"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1448_44631"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.6207,
    height: 30.6207,
    fill: "white",
    transform: "translate(0.689453 0.484375)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.7054d066479861b59a9f6bc883c94288.svg";
export { ForwardRef as ReactComponent };